/**
 * Censo Hogueras
 * Censo-Hogueras
 *
 * OpenAPI spec version: 1.0.0
 * Contact: you@your-company.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Historico } from '../model/historico';
import { ResponseHistoricos } from '../model/responseHistoricos';
import { ResponseStatus } from '../model/responseStatus';
import { Status } from '../model/status';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({providedIn: 'root'})
export class HistoricoService {

    protected basePath = 'https://virtserver.swaggerhub.com/emjf1/Censo-Hogueras/1.0.0';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Eliminar un registro histórico específico
     * Elimina un registro histórico basado en los identificadores proporcionados.
     * @param idAsociacion Identificador único de la asociación.
     * @param idAsociado Identificador del asociado.
     * @param idCargo Identificador del cargo ocupado por el asociado.
     * @param ejercicio Año del ejercicio correspondiente al registro.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public historicoDelete(idAsociacion: number, idAsociado: number, idCargo: number, ejercicio: number, observe?: 'body', reportProgress?: boolean): Observable<ResponseStatus>;
    public historicoDelete(idAsociacion: number, idAsociado: number, idCargo: number, ejercicio: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseStatus>>;
    public historicoDelete(idAsociacion: number, idAsociado: number, idCargo: number, ejercicio: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseStatus>>;
    public historicoDelete(idAsociacion: number, idAsociado: number, idCargo: number, ejercicio: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (idAsociacion === null || idAsociacion === undefined) {
            throw new Error('Required parameter idAsociacion was null or undefined when calling historicoDelete.');
        }

        if (idAsociado === null || idAsociado === undefined) {
            throw new Error('Required parameter idAsociado was null or undefined when calling historicoDelete.');
        }

        if (idCargo === null || idCargo === undefined) {
            throw new Error('Required parameter idCargo was null or undefined when calling historicoDelete.');
        }

        if (ejercicio === null || ejercicio === undefined) {
            throw new Error('Required parameter ejercicio was null or undefined when calling historicoDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ResponseStatus>('delete',`${this.basePath}/historico/${encodeURIComponent(String(idAsociacion))}/${encodeURIComponent(String(idAsociado))}/${encodeURIComponent(String(idCargo))}/${encodeURIComponent(String(ejercicio))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Crear un nuevo registro histórico
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public historicoPost(body: Historico, observe?: 'body', reportProgress?: boolean): Observable<ResponseHistoricos>;
    public historicoPost(body: Historico, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ResponseHistoricos>>;
    public historicoPost(body: Historico, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ResponseHistoricos>>;
    public historicoPost(body: Historico, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling historicoPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (BearerAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ResponseHistoricos>('post',`${this.basePath}/historico`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
